import { VALIDATION_RULES, MESSAGES } from '../constants/warehousesConstants';

export const filterWarehouses = (warehouses = [], searchTerm = '') => {
  if (!searchTerm) return warehouses;

  const normalized = searchTerm.trim().toLowerCase();

  return warehouses.filter((warehouse) => {
    const code = warehouse.code?.toLowerCase() || '';
    const name = warehouse.name?.toLowerCase() || '';
    const address = warehouse.address?.toLowerCase() || '';

    return (
      code.includes(normalized) ||
      name.includes(normalized) ||
      address.includes(normalized)
    );
  });
};

export const validateWarehouse = (formData) => {
  const errors = {};

  if (!formData.code || formData.code.trim() === '') {
    errors.code = MESSAGES.ERROR.REQUIRED_FIELD;
  } else if (formData.code.length > VALIDATION_RULES.CODE_MAX_LENGTH) {
    errors.code = MESSAGES.ERROR.CODE_MAX_LENGTH;
  }

  if (!formData.name || formData.name.trim() === '') {
    errors.name = MESSAGES.ERROR.REQUIRED_FIELD;
  } else if (formData.name.length > VALIDATION_RULES.NAME_MAX_LENGTH) {
    errors.name = MESSAGES.ERROR.NAME_MAX_LENGTH;
  }

  if (formData.address && formData.address.length > VALIDATION_RULES.ADDRESS_MAX_LENGTH) {
    errors.address = MESSAGES.ERROR.ADDRESS_MAX_LENGTH;
  }

  return errors;
};

export const getWarehouseApiErrorMessage = (
  error,
  fallbackMessage = 'No se pudo guardar el depósito'
) => {
  const data = error?.response?.data;

  if (!data) {
    return error?.message || fallbackMessage;
  }

  if (typeof data === 'string') {
    return data;
  }

  const candidates = [data.error, data.detail, data.message];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim().replace(/^Error de validación:\s*/i, '');
    }
  }

  return error?.message || fallbackMessage;
};

export const getBranchName = (branches = [], uuidBranch) => {
  if (!uuidBranch) return '-';
  const branch = branches.find((item) => item.uuid === uuidBranch);
  return branch?.description || '-';
};
